import { Button, Text } from "@/design-system";
import { formatFileSize } from "@/utils";
import { FileText, Image, Video, X } from "lucide-react";

const iconFor = (file: File) =>
  file.type.startsWith("image/")
    ? Image
    : file.type.startsWith("video/")
      ? Video
      : FileText;

type TicketAttachmentListProps = {
  files: File[];
  onRemove: (index: number) => void;
  disabled?: boolean;
};

/** Files picked for a new ticket, each removable before sending. */
export const TicketAttachmentList = ({
  files,
  onRemove,
  disabled = false,
}: TicketAttachmentListProps) => {
  if (files.length === 0) return null;

  return (
    <ul className="flex flex-col gap-2">
      {files.map((file, index) => {
        const Icon = iconFor(file);

        return (
          <li
            key={`${file.name}-${file.lastModified}-${index}`}
            className="border-ds-border rounded-ds-md flex items-center gap-3 border px-3 py-2"
          >
            <Icon size={18} aria-hidden className="text-ds-ink-600 shrink-0" />
            <div className="min-w-0 flex-1">
              <Text size="small" className="truncate">
                {file.name}
              </Text>
              <Text size="caption" tone="muted">
                {formatFileSize(file.size)}
              </Text>
            </div>
            <Button
              variant="ghost"
              shape="circle"
              size="sm"
              aria-label={`Remover ${file.name}`}
              disabled={disabled}
              onClick={() => onRemove(index)}
            >
              <X aria-hidden />
            </Button>
          </li>
        );
      })}
    </ul>
  );
};
